module.exports = __webpack_public_path__ + "static/media/cloudy.66927525.svg";